/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum PopupSizeEnum {
    SMALL = 'SMALL',
    DEFAULT = 'DEFAULT',
    LARGE = 'LARGE',
    EXTRA_LARGE = 'EXTRA_LARGE',
}